import type {
  AiJobStatus,
  Confidence,
  MatchState,
  PriceListStatus,
  PricingStatus,
  ReviewState,
} from "@reina/shared";
import type { PillTone } from "../components";

/**
 * Shared enum → Pill tone/label maps so every screen colours a given state the
 * same way (POC idiom: green = good/done, amber = attention, red = problem).
 */

export const priceListStatusTone: Record<PriceListStatus, PillTone> = {
  draft: "neutral",
  parsing: "warn",
  parsed: "warn",
  published: "ok",
  failed: "danger",
};

export const priceListStatusLabel: Record<PriceListStatus, string> = {
  draft: "Draft",
  parsing: "Parsing…",
  parsed: "Parsed",
  published: "Published",
  failed: "Failed",
};

export const pricingStatusTone: Record<PricingStatus, PillTone> = {
  draft: "neutral",
  matching: "warn",
  ready: "ok",
  finalised: "ok",
  archived: "neutral",
};

export const pricingStatusLabel: Record<PricingStatus, string> = {
  draft: "Draft",
  matching: "Matching…",
  ready: "Ready",
  finalised: "Finalised",
  archived: "Archived",
};

export const matchStateTone: Record<MatchState, PillTone> = {
  unmatched: "danger",
  needs_review: "warn",
  auto_matched: "ok",
  confirmed: "ok",
  rejected: "neutral",
};

export const matchStateLabel: Record<MatchState, string> = {
  unmatched: "Unmatched",
  needs_review: "Needs review",
  auto_matched: "Auto-matched",
  confirmed: "Confirmed",
  rejected: "Rejected",
};

export const confidenceTone: Record<Confidence, PillTone> = {
  high: "ok",
  medium: "warn",
  low: "danger",
};

export const confidenceLabel: Record<Confidence, string> = {
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const reviewStateTone: Record<ReviewState, PillTone> = {
  pending: "warn",
  approved: "ok",
  rejected: "danger",
};

export const reviewStateLabel: Record<ReviewState, string> = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const aiJobStatusTone: Record<AiJobStatus, PillTone> = {
  queued: "neutral",
  running: "warn",
  succeeded: "ok",
  failed: "danger",
};
